export enum TextsSearchTrucker {
  textButton = 'Buscar motorista',
  textFieldPlaceholder = 'Consulte por CPF ou telefone',
  textFieldInvalidErrorMessage = 'Digite um CPF ou telefone válido',
  textBenefitsButton = 'Entenda os benefícios',
  textBenefitsButtonMobile = 'Benefícios',
  textButtonWhatsAppInviteDriver = 'Convidar motorista',
  textButtonTryAgain = 'Tente novamente',
  textButtonCopy = 'Copiar Pix',
  textButtonRiskManagement = 'Gerenciamento de risco',
  textButtonOpenProfile = 'Ver perfil do motorista',
  textButtonOpenProfileMobile = 'Ver perfil',
  textButtonOpenProfileMobileWithChat = 'Perfil do motorista',
  textButtonContactCustomerService = 'Falar com Atendimento',
  textHeaderBenefitsModal = 'Benefícios disponíveis:',
  textWhatsAppUrl = 'https://api.whatsapp.com/send?text=Ol%C3%A1,%20gostaria%20de%20negociar%20com%20voc%C3%AA%20atrav%C3%A9s%20da%20Fretebras.%0AL%C3%A1%20voc%C3%AA%20consegue%20encontrar%20mais%20fretes%20e%20ter%20mais%20seguran%C3%A7a.%0A%0ABaixe%20o%20aplicativo%20pelo%20link:%0Ahttps://play.google.com/store/apps/details?id=br.lgfelicio',
  textWhatsAppCustomerServiceUrl = 'https://wa.me/551141181843',
  textKebabAddContact = 'Adicionar motorista aos contatos',
  textKebabRemoveContact = 'Remover motorista dos contatos',
  textKebabDownloadVerifiedProfile = 'Baixar perfil verificado',
  textKebabShareFreight = 'Compartilhar frete com o motorista',
}

export const benefitsArray = [
  'Acesso a motoristas com perfis completos e verificados pela Fretebras',
  'Garantia contra golpe de adiantamento',
  'Anúncio de frete para motoristas próximos da carga ou indo para o mesmo destino',
  'Visualização do status da viagem em tempo real',
  'Avaliação completa do motorista após viagem',
];

export const openSearchStatesLabels = {
  genericError: {
    title: 'Falha no carregamento',
    message: 'Não foi possível consultar a lista de motoristas no momento. Por favor, tente novamente.',
  },
  notActive: {
    title: 'Cadastro não ativo na plataforma',
    message: 'Utilize o campo acima para a busca de outro profissional.',
  },
  emptyState: {
    title: 'Nenhum motorista encontrado',
    message: 'Convide o motorista para se cadastrar na Fretebras e tenha acesso a benefícios.',
  },
  divergenceError: {
    title: 'Divergência cadastral',
    message: 'Detectamos uma duplicidade de informações cadastrais. Estamos trabalhando para a melhor solução.',
  },
};
